export default function makeErrorString(error: any, placeHolder?: string): string {
    const errorCode = error?.status || error?.statusCode
    const defaultString = !!placeHolder
        ? placeHolder
        : errorCode === 500
            ? '서버 점검 중입니다. 잠시 후 다시 시도해주세요.'
            : '잠시 후 다시 시도해주세요.'
    const result = error?.data?.placeHolder || error?.placeHolder || error?.place_holder || error?.data?.place_holder
    return !!result ? result : defaultString
}